import styles from "./index.module.less";
import ModalConfirm from "../index";
import { useState, useMemo, useEffect } from "react";
import { InputField } from "@wk/components-react16";
import { v4 as uuidv4 } from "uuid";
const valueRegex = /^[a-z0-9_-]+$/;
const nameRegex = /^[\u4e00-\u9fa5a-zA-Z0-9-]+$/;
const AddYyModal = ({
  nameValue,
  title,
  isOpen,
  onClose,
  onConfirm,
  isConfirmLoading = false,
  okText = "确认",
  height = "284px",
  cancelText = "取消",
  onCancel = onClose,
}) => {
  const [name, setName] = useState("");
  const [nameStatus, setNameStatus] = useState("none");

  const nameErrorText = useMemo(() => {
    if (nameStatus === "none") {
      return [];
    }
    if (!name) {
      return [{ label: "请输入机构名称", labelId: "1" }];
    }
    if (!nameRegex.test(name)) {
      return [
        {
          label: "机构名称只能包含中文、英文、数字和短横线！",
          labelId: "2",
        },
      ];
    }

    if (name.length > 20) {
      return [{ label: "机构名称长度不能超过20个字符", labelId: "3" }];
    }

    return [];
  }, [nameStatus, name]);

  const [dataValue, setDataValue] = useState("");
  const [dataStatus, setDataStatus] = useState("none");

  const dataErrorText = useMemo(() => {
    if (dataStatus === "none") {
      return [];
    }
    if (!dataValue) {
      return [{ label: "请输入数据值", labelId: "1" }];
    }

    if (!valueRegex.test(dataValue)) {
      return [
        {
          label: "数据值只能包含小写字母、数字、下划线和短横线！",
          labelId: "2",
        },
      ];
    }
    if (dataValue.length > 50) {
      return [{ label: "数据值长度不能超过50个字符", labelId: "3" }];
    }

    return [];
  }, [dataStatus, dataValue]);

  useEffect(() => {
    if (isOpen) {
      setName(nameValue || "");
    }
  }, [isOpen, nameValue]);

  return (
    <div className={styles["AddYyModal"]}>
      <ModalConfirm
        width="90%"
        title={title}
        isOpen={isOpen}
        onClose={() => {
          onClose();
          setName("");
          setDataValue("");
        }}
        onConfirm={() => {
          if (!name || !nameRegex.test(name) || name.length > 20) {
            setNameStatus("error");
            return;
          }
          let uuid = uuidv4();

          // if (
          //   !dataValue ||
          //   !valueRegex.test(dataValue) ||
          //   dataValue.length > 50
          // ) {
          //   setDataStatus("error");
          //   return;
          // }

          onConfirm({ name, value: uuid }, () => {
            setName("");
            // setDataValue("");
          });
        }}
        isConfirmLoading={isConfirmLoading}
        okText={okText}
        height={height}
        cancelText={cancelText}
        children={
          <div className="content">
            <InputField
              label="机构"
              indicator="required"
              status={nameStatus}
              errors={nameErrorText}
            >
              <input
                type="text"
                placeholder="请输入机构名称"
                required
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  if (
                    !e.target.value ||
                    !nameRegex.test(e.target.value) ||
                    e.target.value.length > 20
                  ) {
                    setNameStatus("error");
                    return;
                  }
                  setNameStatus("none");
                }}
                maxLength={20}
              />
            </InputField>

            {/* <InputField
              label="数据值"
              indicator="required"
              status={dataStatus}
              errors={dataErrorText}
            >
              <input
                type="text"
                placeholder="请输入数据值"
                required
                value={dataValue}
                onChange={(e) => {
                  setDataValue(e.target.value);
                  if (
                    !e.target.value ||
                    !valueRegex.test(e.target.value) ||
                    e.target.value.length > 50
                  ) {
                    setDataStatus("error");
                    return;
                  }
                  setDataStatus("none");
                }}
                maxLength={50}
              />
            </InputField> */}
          </div>
        }
        onCancel={() => {
          onCancel();
          setName("");
          setDataValue("");
        }}
      />
    </div>
  );
};
export default AddYyModal;
